<template>
  <li class="mt-[4px] mb-[4px] w-full px-[10px] py-[6px] border border-[#CFCFCF] rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow text-base">
    <h2 class="uppercase font-jost-medium text-blue-dark text-base">{{ block.chainName }} Block</h2>
    <div class="flex items-center justify-between">    
    <!-- Middle: Block Details -->
    <div class="flex-1 flex items-center gap-[50px] mr-4 min-w-0">
      <!-- Hash - Truncated -->
      <div class="flex items-center min-w-0 flex-2">
        <span class="text-[#6B7280] font-medium mr-1 text-base">Block:</span>
        <router-link
          v-if="block.chainNumber !== undefined && block.chainNumber !== null && block.value !== undefined && block.value !== null"
          class="text-blue-dark cursor-pointer text-base"
          :to="{ name: 'block', params: { chainNumber: block.chainNumber, blockNumber: block.value } }"
        >
          #{{ block.value || 'N/A' }}
        </router-link>
        <span v-else class="text-blue-dark text-base">#{{ block.value || 'N/A' }}</span>
      </div>
      
      <!-- Chain name -->
      <!-- <div class="flex items-center gap-2 text-base flex-2">
        <span class="text-[#6B7280]">Chain Name:</span>
        <RouterLink :to="{ name: 'chain', params: { chainNumber: block.chainNumber } }" class="text-[#374151] font-jost-regular" :title="block.chainName || 'N/A'">
          {{ block.chainName || 'N/A' }}
        </RouterLink>
        </div>
      </div> -->
      
      <!-- Right Side: Value + Time -->
      <!-- <div class="flex items-center gap-4 text-base">
        <div class="text-right">
          <div class="text-[#374151] font-semibold">
            {{ block.transactions || '0' }} Transactions
          </div>
        </div>
        <div class="text-right min-w-[120px]">
          <div class="text-[#374151]">
            {{ block.createdAt ? formatDateTime(block.createdAt) : 'N/A' }}
          </div>
        </div> -->
      </div>
    </div>
  </li>
</template>

<script>
import { 
  formatDateTime, 
  truncateAddress
 } from '@/helpers/common';

export default {
  name: 'BlockCard',
  props: {
    block: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
    truncateAddress(address) {
      return truncateAddress(address);
    },
  }
}
</script>

<style scoped>
.transaction-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
</style>